import { useEffect, useState } from 'react';

import { Deployments } from 'types';

import { EditButton } from '../buttons';

import { createStyles, makeStyles } from '@mui/styles';
import { Dropdown } from '../../../../_shared/Dropdown';
import { canSignUpForDeployment } from 'util/user';

const useStyles = makeStyles(() =>
    createStyles({
        inputContainer: {
            marginBottom: '40px'
        },
        inputFields: {
            background: 'transparent',
            border: '0',
            borderRadius: '6px',
            color: '#1f1f51',
            fontFamily: 'Manrope',
            fontSize: '1.75rem',
            fontWeight: 500,
            letterSpacing: '-0.21px',
            padding: '10px 0px 6px 0px',
            resize: 'none',
            width: '100%',
            '&:placeholder-shown': {
                fontStyle: 'italic'
            },
            '&:focus': {
                outline: 'none !important'
            }
        },
        saveInputBtnContainer: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            paddingBottom: '15px',
            '& button': {
                cursor: 'pointer',
                fontFamily: 'Manrope',
                fontSize: '16px',
                fontWeight: '800'
            }
        },
        saveBtnDisabled: {
            opacity: '50%',
            '& button': {
                cursor: 'auto'
            }
        },
        skipStateContainer: {
            display: 'flex',
            flexDirection: 'row'
        },
        skipStateInput: {
            fontFamily: 'Manrope',
            fontSize: '1.75rem',
            fontWeight: 700
        },
        editIconContainer: {
            cursor: 'pointer',
            height: 'auto',
            margin: '0 0 0 15px',
            width: '1.5rem'
        },
        editIcon: {
            height: 'inherit',
            width: 'inherit'
        },
        editUnderline: {
            backgroundColor: '#E3E4FA',
            border: '3px solid #E3E4FA',
            borderRadius: '10px',
            height: '0'
        },
        menuItem: {
            display: 'flex',
            alignItems: 'center',
            color: '#1f1f51',
            fontFamily: 'Manrope',
            fontSize: '1.75rem',
            fontWeight: 500,
            letterSpacing: '-0.21px'
        },
        orgLogo: {
            borderRadius: '50%',
            height: '32px',
            marginRight: '12px',
            width: '32px'
        },
        orgContainer: {
            display: 'flex',
            paddingTop: '3px'
        },
        optionalLabel: {
            color: '#7A4406',
            fontSize: '0.8rem',
            fontWeight: 100,
            letterSpacing: '0.15em',
            marginLeft: '8px',
            opacity: 0.7
        },
        requiredLabel: {
            color: '#A80A2D',
            fontSize: '0.8rem',
            fontWeight: 100,
            letterSpacing: '0.15em',
            marginLeft: '8px',
            opacity: 0.7
        }
    })
);

//FIXME: Remove editable state intake should always have preselected deployment
type OrgInputProps = {
    deployments: Deployments[];
    intakeInput: number;
    inputTitleClass: (input: string) => string;
    setIntakeInput: (input: number) => void;
};

const OrgInput: React.FC<OrgInputProps> = ({
    deployments,
    intakeInput,
    inputTitleClass,
    setIntakeInput,
}) => {
    const classes = useStyles();

    const [input, setInput] = useState<string>('');
    const [savedInput, setSavedInput] = useState<boolean>(
        intakeInput ? true : false
    );
    const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);

    const handleEditClick = () => {
        setSavedInput(false);
        setDropdownOpen(true);
    };

    useEffect(() => {
        if (intakeInput) {
            const dep = deployments.find((org) => org.id === intakeInput);

            setInput(dep?.name as string);
        }
    }, [deployments, intakeInput]);

    // const showEditButton = ()  => {
    //     deployments.length > 1
    // }
    
    return (
        <div className={classes.inputContainer}>
            <span className={inputTitleClass(intakeInput.toString())}>
                Member's Insurance
                <span className={classes.requiredLabel}>(REQUIRED)</span>
            </span>
            {!savedInput ? (
                <div style={{ padding: '10px 0px', width: '100%' }}>
                    <Dropdown
                        options={deployments.map(dep => ({
                            value: dep.name,
                            label: dep.name,
                            ...(() => {
                                const result = canSignUpForDeployment(dep);
                                if ( intakeInput && intakeInput != dep.id &&  dep.is_eligibility_check_required ) {
                                    return {
                                        disabled: true,
                                        subtitle: "MEMBER INELIGIBLE"
                                    };
                                }
                                return {
                                    disabled: !result.canSignUp,
                                    subtitle: !result.canSignUp ? result.errorMessage?.shortReason : ''
                                };
                            })()
                        }))}
                        value={input}
                        placeholder="Click to select"
                        open={dropdownOpen}
                        onOpenChange={setDropdownOpen}
                        onChange={(value) => {
                            const dep = deployments.find(dep => dep.name === value) as Deployments;
                            setInput(dep.name);
                            setIntakeInput(dep.id);
                            setSavedInput(true);
                            setDropdownOpen(false);
                        }}
                        aria-label={"Member's Insurance - Select insurance organization"}
                    />
                </div>
            ) : (
                <div className={classes.orgContainer}>
                    <EditButton
                        handleEditClick={handleEditClick}
                        inputValState={input}
                        saveInputState={savedInput}
                        showEditButton={false}
                        ariaLabel="Edit Member's Insurance"
                    />
                </div>
            )}
        </div>
    );
};

export default OrgInput;
